import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import EditableSection from 'components/v2/EditableSection';
import Select from 'components/v2/select';

const Operation = ({ data, onUpdateCarrier, className }) => {
  const { t } = useTranslation();
  const [initialData, setInitialData] = useState({});
  const [operationsData, setOperationsData] = useState({});

  const getInitData = () => {
    if (data) {
      setInitialData(data);
      setOperationsData(data);
    }
  };
  useEffect(() => {
    getInitData();
  }, [data]);

  const onChange = (field, value) => {
    setOperationsData((prev) => ({ ...prev, [field]: value }));
  };
  const handleSave = async () => {
    const updates = {};
    const { ...changed } = operationsData;
    Object.keys(changed).forEach((key) => {
      if (initialData[key] !== changed[key]) {
        updates[key] = changed[key];
      }
    });
    if (Object.keys(updates).length) {
      await onUpdateCarrier(updates);
    }
  };
  const handleAfterSave = (onSaveSuccess) => {
    return (updatedData = {}) => {
      setInitialData((prev) => ({ ...prev, ...updatedData }));
      onSaveSuccess();
    };
  };
  return (
    <EditableSection
      title={t('OPERATIONS')}
      className={classNames(className)}
      canEdit
    >
      {(editing, saving, onSaveSuccess, onSaveFail) =>
        !editing ? (
          <OperationSummary fields={initialData} />
        ) : (
          <OperationForm
            fields={operationsData}
            onChange={onChange}
            onSaveCarrier={() => handleSave()}
            saving={saving}
            onSaveSuccess={handleAfterSave(onSaveSuccess)}
            onSaveFail={onSaveFail}
          />
        )
      }
    </EditableSection>
  );
};

const OperationSummary = ({ fields = {} }) => {
  const { t } = useTranslation();
  const { data_entry_agent, carrier_success_manager, account_support_agent } =
    fields;
  const na = t('NONE');
  return (
    <div className="grid grid-cols-1 gap-4">
      <DescriptionListItem label={t('DATA_ENTRY')}>
        {data_entry_agent || na}
      </DescriptionListItem>
      <DescriptionListItem label={t('CARRIER_SUCCESS_REPRESENTATIVE')}>
        {carrier_success_manager || na}
      </DescriptionListItem>
      <DescriptionListItem label={t('ACCOUNT_SUPPORT')}>
        {account_support_agent || na}
      </DescriptionListItem>
    </div>
  );
};

const OperationForm = ({
  fields,
  onChange,
  saving,
  onSaveCarrier,
  onSaveSuccess,
  onSaveFail,
}) => {
  const { t } = useTranslation();
  const saveForm = async () => {
    try {
      await onSaveCarrier();
      onSaveSuccess(fields);
    } catch (e) {
      onSaveFail();
    }
  };
  useEffect(() => {
    if (saving) {
      saveForm();
    }
  }, [saving]);
  const { admins } = fields;
  return (
    <div className="grid gap-4">
      <Select
        items={admins}
        valueKey="slug"
        textKey="name"
        selected={fields.data_entry_agent}
        onSelect={({ slug }) => onChange('data_entry_agent', slug)}
        info={t('DATA_ENTRY_TIP')}
        label={t('DATA_ENTRY')}
        inputClassNames="lg:w-4/5 w-1/2"
      />
      <Select
        items={admins}
        valueKey="slug"
        textKey="name"
        selected={fields.carrier_success_manager}
        onSelect={({ slug }) => onChange('carrier_success_manager', slug)}
        info={t('CARRIER_SUCCESS_REPRESENTATIVE_TIP')}
        label={t('CARRIER_SUCCESS_REPRESENTATIVE')}
        inputClassNames="lg:w-4/5 w-1/2"
      />
      <Select
        items={admins}
        valueKey="slug"
        textKey="name"
        selected={fields.account_support_agent}
        onSelect={({ slug }) => onChange('account_support_agent', slug)}
        info={t('ACCOUNT_SUPPORT_TIP')}
        label={t('ACCOUNT_SUPPORT')}
        inputClassNames="lg:w-4/5 w-1/2"
      />
    </div>
  );
};

export default Operation;
